import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import "./styles/index.css";

// useTransitions={false} keeps the router's state updates on the same lane as
// ordinary setState, which is what v6 did unless you opted in via the
// future.v7_startTransition flag. Router v7 flipped that default, and several
// pages call navigate() and then clear a "busy" flag in the same finally block.
// On the v7 default those two updates land in separate commits, and the first
// one re-renders the page you are leaving with its submit button live again.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter useTransitions={false}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
